(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('SecurityRoleController', SecurityRoleController);

    /* @ngInject */
    function SecurityRoleController($scope, $state, triSettings, SecurityRole, ParseLinks, AlertService, pagingParams, paginationConstants, $mdDialog, $mdToast, $stateParams, PermissionService, $filter) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.transition = transition;
        vm.removeFilter = removeFilter;

        vm.createObject = createObject;
        vm.editObject = editObject;
        vm.deleteObject = deleteObject;

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        $scope.secondaryColor = triSettings.getSkinModel().secondary_color_hex;

        vm.permissions = {
            create : 'manage-security-role-system',
            update : 'manage-security-role-system',
            delete : 'manage-security-role-system',
            manage : 'manage-security-role-system'
        };

        vm.hasDeletePermission = PermissionService.hasAccess(vm.permissions.manage);

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.filter = {
            show: false,
            options: {
                debounce: 500
            }
        };

        function loadAll() {
            SecurityRole.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.securityRoles = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition() {
            vm.promise = SecurityRole.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.securityRoles = data;
            });
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';

            if (vm.filter.form.$dirty) {
                vm.filter.form.$setPristine();
            }
        }

        function createObject() {
            $state.go('storm.admin-setting.security-role-detail');
        }

        function editObject(objectId) {
            $state.go('storm.admin-setting.security-role-detail', {
                'id': objectId
            });
        }

        function deleteObject(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.securityRole.deleteObject'))
                .ariaLabel($filter('translate')('atheer.securityRole.deleteObject'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                SecurityRole.delete({
                    id: entity.id
                }, function() {
                    resetModal();
                });
            });
        };

        function getQueryString() {
            if (vm.query.filter.length <= 0) {
                return 'acl==false';
            } else {
                return 'acl==false;name=re=' + vm.query.filter;
            }
        }

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
        }

        vm.removeFilter = function() {
            vm.filter.show = false;
            vm.query.filter = '';
            resetModal();
        };

        vm.openAssignModal = function(securityRole) {
            $mdDialog.show({
                templateUrl: 'modules/system/security-role/security-role-assign-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: "SecurityRoleAssignController",
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    securityRole: securityRole,
                    userId: undefined
                }
            });
        }
        vm.loadAll();
    }
})();
